
import service from "../util/request";
 
/**
 * 获取新闻列表
 */
export function getNews(data) {
  return service.request({
    url: "/estar_system/journalism/select",
    method: "POST",
    data,
  })
}

/**
 * 获取文件列表
 */
 export function getFiles() {
  return service.request({
    url: "/estar_system/file/selectAll",
    method: "GET",
  })
}

/**
 * 根据id查询文件
 */
 export function getFileById(data) {
  return service.request({
    url: "/estar_system/optionFile/select",
    method: "POST",
    data,
  })
}